export const configFile = '/assets/json/config.json';
export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"];
export const appMessages = {
    'receipt':{
        'success':'This stock movement has automatically been receipted. There is no need for further action.',
        'error':''
    },
    'move':{
        'success':'This stock insert has automatically been receipted. There is no need for further action.',
        'successRsl':'This stock has been issued, it is now ready to be receipted. where its FE to RSL and 3rd party courier ref is needed.',
        'error':{
            'default':'Stock movement has an error.',
            'iden-consignno':'An outstanding receipt with an identical CONSIGNMENT NUMBER value has been automatically receipted into ',
            'iden-courierno':'An outstanding receipt with an identical COURIER NUMBER value has been automatically receipted into '
        }
    },
    'abandon':{
        'success':'',
        'error':''
    },
    'bootkit':{
        'success':'',
        'error':''
    },
    'stockinsert':{
        'success':'This stock insert has automatically been receipted. There is no need for further action.',
        'error':'An outstanding receipt with an identical CONSIGNMENT NUMBER value has been automatically receipted in a QUARANTINE'
    },
    'partsusage':{
        'success':'Part successfully used on Work Order',
        'error':'Work Order Number entered is not associated with an open Work Order.'
    },
    'classes':{
        'success':'bg-success text-white  font-weight-bold',
        'error':'bg-danger text-white  font-weight-bold',
        'warning':'bg-warning text-white  font-weight-bold'
    }
};
export const testlinkobj = [
    {
        "name": "Defective",
        "value": "DEFECTIVE"
    },
    {
        "name": "DOA",
        "value": "DOA"
    },
    {
        "name": "WPIB",
        "value": "WPIB"
    },
    {
        "name": "Project Part",
        "value": "PROJECT WORK"
    },
    {
        "name": "New",
        "value": "KNOWN GOOD"
    },
    {
        "name": "Early Life Failure",
        "value": "EARLY LIFE FAILURE"
    }
];